import React from 'react'

export default function Biography() {
  return (
    <div className='m-2' style={{height:"89vh", textAlign:"center", justifyContent:"center", display:"flex", flexDirection:"column"}}>
      <h2>This is meant to be the biography page.</h2>
      <p></p>
      <p>But sorry it is not finished yet :'(</p>
      <p>Feel free to come back and check me out in another time!</p>
    </div>
  )
}
